module.exports = __webpack_public_path__ + "img/y_2.4e82ccae.png";